// Mock data for vetoRDV

export const animalTypes = [
  { id: 'chien', label: 'Chien', icon: '🐕' },
  { id: 'chat', label: 'Chat', icon: '🐱' },
  { id: 'nac', label: 'NAC', icon: '🐰' },
  { id: 'equin', label: 'Équin', icon: '🐴' },
  { id: 'elevage', label: 'Élevage', icon: '🐄' },
];

export const cliniques = [
  {
    id: 1,
    name: 'Clinique Vétérinaire du Parc',
    address: '12 Rue des Animaux, 75001 Paris',
    phone: '01 23 45 67 89',
    rating: 4.8,
    reviews: 124,
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=400',
    animals: ['chien', 'chat', 'nac'],
    availableSlots: ['09:00', '10:30', '14:00', '16:00'],
    latitude: 48.8606,
    longitude: 2.3376,
    city: 'Paris'
  },
  {
    id: 2,
    name: 'Vétérinaires Associés Saint-Michel',
    address: '45 Boulevard Saint-Michel, 75005 Paris',
    phone: '01 98 76 54 32',
    rating: 4.6,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=400',
    animals: ['chien', 'chat', 'equin'],
    availableSlots: ['08:30', '11:00', '13:30', '17:00'],
    latitude: 48.8494,
    longitude: 2.3445,
    city: 'Paris'
  },
  {
    id: 3,
    name: 'Centre Vétérinaire de Lyon',
    address: '78 Avenue Jean Jaurès, 69007 Lyon',
    phone: '04 12 34 56 78',
    rating: 4.9,
    reviews: 201,
    image: 'https://images.unsplash.com/photo-1628009368231-7bb7cf50d23b?w=400',
    animals: ['chien', 'chat', 'nac', 'elevage'],
    availableSlots: ['09:30', '12:00', '15:00', '18:00'],
    latitude: 45.7485,
    longitude: 4.8467,
    city: 'Lyon'
  },
  {
    id: 4,
    name: 'Clinique Vétérinaire Bordeaux Centre',
    address: '23 Cours de l\'Intendance, 33000 Bordeaux',
    phone: '05 56 12 34 56',
    rating: 4.7,
    reviews: 156,
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400',
    animals: ['chien', 'chat', 'nac'],
    availableSlots: ['08:00', '10:00', '14:30', '16:30'],
    latitude: 44.8378,
    longitude: -0.5792,
    city: 'Bordeaux'
  },
  {
    id: 5,
    name: 'SOS Vétérinaires Marseille',
    address: '156 La Canebière, 13001 Marseille',
    phone: '04 91 23 45 67',
    rating: 4.5,
    reviews: 98,
    image: 'https://images.unsplash.com/photo-1576201836106-db1758fd1c97?w=400',
    animals: ['chien', 'chat', 'nac', 'equin'],
    availableSlots: ['09:00', '11:30', '14:00', '17:30'],
    latitude: 43.2965,
    longitude: 5.3698,
    city: 'Marseille'
  },
  {
    id: 6,
    name: 'Clinique Vétérinaire Nantes Atlantique',
    address: '89 Rue Crébillon, 44000 Nantes',
    phone: '02 40 12 34 56',
    rating: 4.8,
    reviews: 112,
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400',
    animals: ['chien', 'chat', 'nac', 'elevage'],
    availableSlots: ['08:30', '10:30', '13:00', '15:30'],
    latitude: 47.2184,
    longitude: -1.5536,
    city: 'Nantes'
  }
];

// Articles/Conseils avec contenu complet
export const defaultConseils = [
  {
    id: 1,
    title: 'Comment bien prendre soin d\'un chien âgé ?',
    excerpt: 'Le temps passe et votre chien vieillit, c\'est une étape inévitable de votre vie commune. Ses habitudes évoluent, son rythme ralentit, et il demande davantage d\'attention au quotidien.',
    content: `Le temps passe et votre chien vieillit, c'est une étape inévitable de votre vie commune. Ses habitudes évoluent, son rythme ralentit, et il demande davantage d'attention au quotidien. Si cette période peut parfois sembler délicate, de simples gestes peuvent faire une réelle différence pour son bien-être.

## Adapter son alimentation

Avec l'âge, les besoins nutritionnels de votre chien changent. Optez pour une alimentation spécifique "senior" qui prend en compte :
- Une teneur réduite en calories pour éviter la prise de poids
- Des protéines de haute qualité pour maintenir la masse musculaire
- Des compléments pour les articulations (glucosamine, chondroïtine)
- Des antioxydants pour soutenir le système immunitaire

## Maintenir une activité physique adaptée

Même si votre chien est moins actif, l'exercice reste essentiel. Privilégiez :
- Des promenades plus courtes mais plus fréquentes
- Des jeux calmes et stimulants mentalement
- De la natation si possible, excellente pour les articulations

## Surveiller sa santé de près

Les visites vétérinaires doivent être plus régulières (tous les 6 mois). Soyez attentif aux signes suivants :
- Difficultés à se lever ou à monter les escaliers
- Perte d'appétit ou de poids
- Changements de comportement
- Problèmes de vision ou d'audition

## Aménager son environnement

Facilitez le quotidien de votre compagnon :
- Un couchage orthopédique et accessible
- Des gamelles surélevées
- Des rampes pour accéder au canapé ou à la voiture
- Un sol antidérapant`,
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600',
    date: '11 septembre 2025',
    tags: ['Chien', 'Santé'],
    category: 'chien',
    author: 'Dr. Marie Lambert'
  },
  {
    id: 2,
    title: 'La socialisation du chiot ou du chaton : quelles sont les étapes clés ?',
    excerpt: 'La socialisation est un apprentissage essentiel pour un chiot ou un chaton. Elle intervient très tôt dans la vie de l\'animal et lui permet d\'apprendre à interagir sereinement.',
    content: `La socialisation est un apprentissage essentiel pour un chiot ou un chaton. Elle intervient très tôt dans la vie de l'animal et lui permet d'apprendre à interagir sereinement avec son environnement.

## Qu'est-ce que la période de socialisation ?

Cette période critique se situe :
- **Chez le chiot** : entre 3 et 12 semaines
- **Chez le chaton** : entre 2 et 7 semaines

Durant cette fenêtre, le cerveau est particulièrement réceptif aux nouvelles expériences.

## Les étapes clés de la socialisation

### 1. Contact avec les humains
- Manipulez doucement votre animal chaque jour
- Faites-le rencontrer des personnes de tous âges
- Habituez-le aux enfants (sous surveillance)

### 2. Contact avec d'autres animaux
- Organisez des rencontres avec des animaux vaccinés et sociables
- Les cours de socialisation pour chiots sont excellents
- Pour les chatons, le contact avec la mère et la fratrie est crucial

### 3. Découverte de l'environnement
- Bruits domestiques (aspirateur, sèche-cheveux)
- Bruits extérieurs (voitures, vélos)
- Différentes surfaces (herbe, carrelage, gravier)

### 4. Expériences positives
- Visites chez le vétérinaire sans soins (juste pour les friandises !)
- Trajets en voiture
- Toilettage et manipulation des pattes

## Conseils pratiques

- Toujours associer les nouvelles expériences à quelque chose de positif
- Ne jamais forcer l'animal
- Respecter son rythme
- Être patient et régulier`,
    image: 'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?w=600',
    date: '23 août 2025',
    tags: ['Adoption', 'Chat', 'Chien'],
    category: 'adoption',
    author: 'Dr. Sophie Martin'
  },
  {
    id: 3,
    title: 'Comment prendre soin de son animal de compagnie au printemps ?',
    excerpt: 'Le printemps est enfin là ! Et tout comme pour nous, c\'est le temps des changements. Fini la routine hivernale, il est temps de profiter des rayons du soleil.',
    content: `Le printemps est enfin là ! Et tout comme pour nous, c'est le temps des changements pour nos animaux de compagnie. Voici comment les accompagner au mieux durant cette saison.

## La mue printanière

Au printemps, chiens et chats perdent leur pelage d'hiver :
- Brossez votre animal quotidiennement
- Utilisez une brosse adaptée à son type de poil
- Un toilettage professionnel peut être utile

## Protection contre les parasites

Le retour des beaux jours signifie aussi le retour des parasites :

### Les puces
- Traitez préventivement dès le mois de mars
- N'oubliez pas de traiter l'environnement

### Les tiques
- Vérifiez votre animal après chaque promenade
- Utilisez un tire-tique pour les retirer correctement
- Consultez en cas de rougeur ou de fièvre

### Les chenilles processionnaires
- Très dangereuses pour les chiens
- Évitez les zones à risque (pins)
- Consultez en urgence en cas de contact

## Les allergies saisonnières

Comme les humains, les animaux peuvent être allergiques aux pollens :
- Symptômes : démangeaisons, éternuements, yeux qui coulent
- Rincez les pattes après les promenades
- Consultez votre vétérinaire si les symptômes persistent

## Reprendre l'activité physique

- Augmentez progressivement la durée des promenades
- Attention aux coups de chaleur dès que les températures montent
- Hydratez bien votre animal`,
    image: 'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=600',
    date: '7 avril 2025',
    tags: ['Chat', 'Chien', 'Vie pratique'],
    category: 'chat',
    author: 'Dr. Pierre Dubois'
  },
  {
    id: 4,
    title: 'L\'alimentation équilibrée pour votre chat',
    excerpt: 'Une alimentation adaptée est essentielle pour la santé de votre chat. Découvrez nos conseils pour bien nourrir votre félin au quotidien.',
    content: `Une alimentation adaptée est essentielle pour la santé de votre chat. Voici tout ce que vous devez savoir pour bien nourrir votre félin.

## Les besoins nutritionnels du chat

Le chat est un carnivore strict, ses besoins sont spécifiques :
- **Protéines** : minimum 25-30% de la ration
- **Taurine** : acide aminé essentiel (le chat ne le synthétise pas)
- **Acides gras** : oméga 3 et 6 pour le pelage
- **Eau** : les chats boivent peu naturellement

## Alimentation sèche ou humide ?

### Les croquettes
- Pratiques et économiques
- Bonnes pour l'hygiène dentaire
- Choisissez une qualité premium

### La pâtée
- Riche en eau (80%)
- Plus appétissante
- Idéale pour les chats qui boivent peu

### L'idéal : le bi-nutrition
Combinez les deux pour bénéficier des avantages de chaque type.

## Les erreurs à éviter

- Donner du lait de vache (la plupart des chats sont intolérants)
- Les restes de table (trop salés, épicés)
- Le chocolat, l'oignon, l'ail (toxiques)
- Les changements alimentaires brutaux

## Quelle quantité donner ?

La quantité dépend de plusieurs facteurs :
- Âge et poids de votre chat
- Niveau d'activité
- Stérilisation ou non

Référez-vous aux indications sur l'emballage et ajustez selon l'évolution du poids.

## L'importance de l'eau

Pour encourager votre chat à boire :
- Fontaine à eau
- Plusieurs points d'eau dans la maison
- Eau fraîche changée quotidiennement`,
    image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=600',
    date: '15 mars 2025',
    tags: ['Chat', 'Alimentation'],
    category: 'chat',
    author: 'Dr. Marie Lambert'
  },
  {
    id: 5,
    title: 'Les vaccinations essentielles pour votre chien',
    excerpt: 'La vaccination est un acte préventif indispensable pour protéger votre chien contre de nombreuses maladies. Voici le calendrier vaccinal recommandé.',
    content: `La vaccination est un acte préventif indispensable pour protéger votre chien contre de nombreuses maladies graves, parfois mortelles.

## Pourquoi vacciner son chien ?

La vaccination permet de :
- Protéger votre chien contre des maladies graves
- Éviter la propagation de maladies contagieuses
- Certains vaccins sont obligatoires (rage pour voyager)

## Les vaccins essentiels ("core vaccines")

### La maladie de Carré
Très contagieuse et souvent mortelle. Symptômes : fièvre, troubles respiratoires et nerveux.

### L'hépatite de Rubarth
Atteinte du foie pouvant être fatale.

### La parvovirose
Très dangereuse pour les chiots. Provoque des gastro-entérites hémorragiques sévères.

### La leptospirose
Transmise par l'urine des rongeurs. Peut aussi contaminer l'homme.

### La rage
Obligatoire pour voyager à l'étranger. Mortelle une fois déclarée.

## Le calendrier vaccinal

| Âge | Vaccins |
|-----|--------|
| 8 semaines | Primo-vaccination (CHPPi + L) |
| 12 semaines | Rappel + Rage si nécessaire |
| 16 semaines | Rappel |
| 1 an | Premier rappel annuel |
| Puis chaque année | Rappels |

## Vaccins optionnels selon le mode de vie

- **Toux de chenil** : si votre chien va en pension ou en collectivité
- **Leishmaniose** : si vous vivez ou voyagez dans le sud
- **Piroplasmose** : selon l'exposition aux tiques

## Après la vaccination

Quelques précautions :
- Légère fatigue possible pendant 24-48h
- Petite boule au point d'injection (disparaît en quelques jours)
- Consultez si fièvre ou réaction importante`,
    image: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=600',
    date: '28 février 2025',
    tags: ['Chien', 'Santé', 'Prévention'],
    category: 'chien',
    author: 'Dr. Jean-Pierre Moreau'
  },
  {
    id: 6,
    title: 'Adopter un NAC : ce qu\'il faut savoir',
    excerpt: 'Les Nouveaux Animaux de Compagnie séduisent de plus en plus de familles. Mais avant d\'adopter un lapin, un furet ou un reptile, il y a des points essentiels à connaître.',
    content: `Les Nouveaux Animaux de Compagnie (NAC) séduisent de plus en plus de familles. Mais ces animaux ont des besoins très spécifiques qu'il faut connaître avant de se lancer.

## Qu'est-ce qu'un NAC ?

Le terme NAC regroupe tous les animaux de compagnie autres que les chiens et chats :
- Rongeurs (lapin, cochon d'Inde, hamster, chinchilla)
- Furets
- Reptiles (tortues, lézards, serpents)
- Oiseaux
- Poissons

## Les questions à se poser avant l'adoption

### 1. Ai-je l'espace nécessaire ?
Chaque espèce a des besoins d'espace spécifiques. Un lapin a besoin de beaucoup plus de place qu'on ne le pense !

### 2. Ai-je le budget ?
- Alimentation spécifique
- Matériel adapté (terrarium, cage, etc.)
- Frais vétérinaires (souvent plus élevés car spécialisés)

### 3. Ai-je le temps ?
Certains NAC demandent beaucoup d'interactions (furet, perroquet).

### 4. Y a-t-il un vétérinaire NAC près de chez moi ?
Tous les vétérinaires ne soignent pas les NAC.

## Focus sur quelques espèces

### Le lapin
- Durée de vie : 8-12 ans
- Besoin d'espace : minimum 2m²
- Alimentation : foin à volonté, légumes frais
- Social : vit mieux en duo

### Le cochon d'Inde
- Durée de vie : 5-8 ans
- Très social, à adopter par deux minimum
- A besoin de vitamine C quotidienne

### Le furet
- Durée de vie : 6-10 ans
- Très joueur et curieux
- Doit sortir plusieurs heures par jour
- Odeur caractéristique

## La législation

Certains NAC nécessitent des autorisations spécifiques (certificat de capacité). Renseignez-vous avant toute adoption.`,
    image: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?w=600',
    date: '10 janvier 2025',
    tags: ['NAC', 'Adoption'],
    category: 'nac',
    author: 'Dr. Claire Petit'
  },
  {
    id: 7,
    title: 'Les signes de douleur chez le chat : comment les reconnaître ?',
    excerpt: 'Les chats sont des maîtres dans l\'art de cacher leur douleur. Apprenez à reconnaître les signes subtils qui doivent vous alerter.',
    content: `Les chats sont des experts pour masquer leur douleur, un héritage de leur passé de prédateur. Voici comment détecter les signes subtils de souffrance.

## Pourquoi les chats cachent-ils leur douleur ?

Dans la nature, montrer sa faiblesse c'est devenir une proie. Ce réflexe de survie persiste chez nos chats domestiques.

## Les signes comportementaux

### Changement d'activité
- Chat habituellement actif qui devient léthargique
- Ou inversement, agitation inhabituelle
- Réticence à sauter ou monter les escaliers

### Changement d'appétit
- Perte d'appétit
- Difficulté à manger (problèmes dentaires)

### Changement dans les interactions
- Chat sociable qui s'isole
- Agressivité inhabituelle quand on le touche
- Recherche excessive d'attention

### Changement de toilettage
- Léchage excessif d'une zone (douleur localisée)
- Ou arrêt du toilettage (poil terne, nœuds)

## Les signes physiques

### La posture
- Position voûtée
- Tête basse
- Pattes repliées sous le corps

### Le visage
- Oreilles aplaties ou en arrière
- Yeux mi-clos ou au contraire grands ouverts
- Moustaches vers l'arrière
- Expression "tendue"

### La respiration
- Respiration rapide et superficielle
- Halètement (rare chez le chat, signe d'alerte)

## Les vocalisations

- Miaulements plaintifs
- Grognements quand on le touche
- Ronronnement (parfois signe d'auto-apaisement)

## Quand consulter ?

N'attendez pas si vous observez plusieurs de ces signes. Un chat qui montre sa douleur souffre probablement depuis un moment déjà.`,
    image: 'https://images.unsplash.com/photo-1495360010541-f48722b34f7d?w=600',
    date: '5 décembre 2024',
    tags: ['Chat', 'Santé'],
    category: 'chat',
    author: 'Dr. Sophie Martin'
  },
  {
    id: 8,
    title: 'Voyager avec son animal : les conseils pratiques',
    excerpt: 'Vous partez en vacances avec votre compagnon à quatre pattes ? Voici tous nos conseils pour un voyage serein.',
    content: `Partir en vacances avec son animal demande un peu de préparation. Voici notre guide complet pour un voyage réussi.

## Avant le départ

### Les documents nécessaires
- Carnet de santé à jour
- Passeport européen (pour l'étranger)
- Vaccination rage obligatoire pour l'UE
- Puce électronique

### Préparer son animal
- Habituez-le progressivement à la cage de transport
- Faites des petits trajets d'entraînement
- Consultez votre vétérinaire si votre animal est anxieux

## Le voyage en voiture

### Sécurité
- Cage de transport ou harnais homologué
- Ne jamais laisser l'animal en liberté dans l'habitacle
- Ne JAMAIS laisser un animal seul dans une voiture

### Confort
- Pause toutes les 2 heures
- Eau fraîche à disposition
- Climatisation modérée
- Dernier repas 3-4h avant le départ

## Le voyage en train

- Petits animaux (<6kg) : dans un sac de transport, gratuit ou tarif réduit
- Grands chiens : billet spécifique, muselière parfois obligatoire
- Réservez à l'avance

## Le voyage en avion

### En cabine
- Généralement réservé aux animaux de moins de 8kg (sac compris)
- Sac de transport aux dimensions réglementaires

### En soute
- Caisse homologuée IATA
- Prévoir eau et couverture
- À éviter pour les races à nez écrasé

## Sur place

### Hébergement
- Vérifiez que les animaux sont acceptés
- Certains hôtels demandent un supplément
- Emportez le couchage habituel de votre animal

### La trousse de secours
- Médicaments habituels
- Antiparasitaires
- Désinfectant
- Coordonnées d'un vétérinaire sur place`,
    image: 'https://images.unsplash.com/photo-1541599540903-216a46ca1dc0?w=600',
    date: '20 novembre 2024',
    tags: ['Chien', 'Chat', 'Vie pratique'],
    category: 'chien',
    author: 'Dr. Pierre Dubois'
  }
];

export const tags = ['Tous', 'Chien', 'Chat', 'NAC', 'Santé', 'Alimentation', 'Adoption', 'Vie pratique', 'Prévention'];

export const features = [
  {
    icon: 'PlusCircle',
    title: 'Trouvez un vétérinaire',
    description: 'Trouvez un vétérinaire parmi les 7000 cliniques répertoriées sur notre site internet'
  },
  {
    icon: 'Calendar',
    title: 'Réservez un créneau',
    description: 'Sélectionnez un créneau directement pour prendre rendez-vous en ligne'
  },
  {
    icon: 'MessageSquare',
    title: 'Rappel SMS',
    description: 'Recevez un rappel par SMS la veille du rendez-vous pour ne pas l\'oublier'
  }
];

export const avantages = [
  {
    icon: 'PawPrint',
    title: 'Pour tous les animaux',
    description: 'Animaux domestiques, nouveaux animaux de compagnie, équins (cheval), animaux d\'élevage...'
  },
  {
    icon: 'Clock',
    title: 'Une prise de rendez-vous simple et rapide',
    description: 'Gagnez du temps dans la recherche d\'un vétérinaire et la prise de rendez-vous.'
  },
  {
    icon: 'Bell',
    title: 'Rappel de votre rendez-vous',
    description: 'Une fois le rendez-vous pris, vous recevrez un rappel par email et SMS la veille du rendez-vous.'
  }
];
